/**
 * Purpose:
 *   Tailwind class names for the shared page-level loading, error, and not-found state layout.
 */

export const pageStateStyles = {
  contentWrapper: 'contents',
  hiddenContent: 'hidden',
  container: 'flex flex-col items-center justify-center gap-4 text-center',
  loadingContainer: 'px-6 py-10',
  blankContainer: 'px-6 py-6',
  loadingMessage: 'b2 text-blue-700',
  actions: 'mt-2 flex flex-wrap items-center justify-center gap-3',
} as const;
